import { t } from "i18next"
import cn from "clsx"
import { useUnit } from "effector-react"
import { $whiteLabel } from "@callcenter/white-label"

import styles from "./styles.module.pcss"

type LogoProps = {
  className?: string
}

export const Logo = ({ className }: LogoProps) => {
  const { brandLogoUrl, omnichannelLogoUrl, brandName } = useUnit($whiteLabel.$whiteLabelSettings)

  const isNativeBrand = brandName?.toLocaleLowerCase() === t("component_component_commonBrandLowercaseOne")

  return (
    <div className={cn(styles.container, className)}>
      <img
        className={styles.logo}
        src={brandLogoUrl || omnichannelLogoUrl || ""}
        alt="logo"
        width={isNativeBrand ? 106 : "auto"}
      />
    </div>
  )
}
